<div class="modal-content">
  <div class="modal-header">
    <div>Unsaved changes</div>
  </div>
  <div class="icon-button position-top-right" data-dismiss="modal" tabindex="0">
    <span aria-hidden="true"><i class="bi bi-x"></i></span>
  </div>
  <div class="modal-body">
    If you switch away from the editing screen, you will lose all the changes you have made.
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" data-dismiss="modal" type="button">Continue editing</button>
    <button (click)="close()" class="btn btn-primary" type="button">Close without saving</button>
  </div>
</div>

